<template>
  <wide-box-section class="single-service-content">
    <router-link to="/services"><img class="back-arrow" src="../assets/back-arrow-dark.svg" alt=""></router-link>
    <h1>{{ title }}</h1>
    <p v-html="content"></p>
    <div class="img-wrap" slot="sidebar"><img :src="sideImage" alt=""></div>
    <div class="corner-box" slot="corner-box">
      <router-link :to="button.link" class="blue" v-if="button.link && button.text"><span>{{ button.text }}</span><img src="../assets/forward-arrow-dark.svg" alt=""></router-link>
      <router-link to="/contact" class="red"><span>Get in touch.</span><img src="../assets/forward-arrow-dark.svg" alt=""></router-link>
    </div>
  </wide-box-section>
</template>

<script>
import WideBoxSection from './WideBoxSection'
import axios from 'axios'

export default {
  name: 'Services',

  components: { WideBoxSection },

  data () {
    return {
      title: '',
      content: '',
      button: {
        text: '',
        link: ''
      },
      serviceIcons: {
        'audit-of-financial-statements': require('../assets/service-icons/audit.svg'),
        'internal-audits': require('../assets/service-icons/internal.svg'),
        'other-assurance-and-advisory-services': require('../assets/service-icons/other.svg'),
        'public-service-audits-and-advisory': require('../assets/service-icons/public-service.svg'),
        'review-of-financial-statements': require('../assets/service-icons/review.svg'),
        'system-reviews-and-documentations': require('../assets/service-icons/system-reviews.svg'),
        'aml-cft-audits': require('../assets/service-icons/aml-laundering.svg')
      },
      metaInfo: {
        title: 'Services'
      }
    }
  },

  metaInfo () {
    return {
      title: this.metaInfo.title
    }
  },

  mounted () {
    this.sideImage = this.serviceIcons[this.$route.params.name]
    axios.get(process.env.ENDPOINT, {
      params: {
        slug: this.$route.params.name
      }
    }).then(response => {
      this.title = response.data[0].title.rendered
      this.metaInfo.title = response.data[0].title.rendered
      this.content = response.data[0].content.rendered
      this.button.text = response.data[0].acf.button_text
      this.button.link = response.data[0].acf.button_link
      document.dispatchEvent(new Event('content-loaded'))
    }).catch(error => {
      console.log(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SingleService.vue